/* eslint-disable import/no-unresolved */
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Col from "react-bootstrap/lib/Col";
import { push } from "react-router-redux";
import { func, bool, string } from "prop-types";

import { actions as communicationsActions, selectors as communicationsSelector } from "reducers/communications";
import { actions as communicationActions, selectors as communicationSelectors } from "reducers/communication";
import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";
import { getPostLoginHomePath } from "util/v3UxConfig";

import List from "pages/communications/_components/List";
import Head from "pages/_components/Head";
import Button from "pages/_components/Button";
import Image from "pages/_components/Image";
import LeftPanel from "pages/communications/_components/LeftPanel";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import Container from "pages/_components/Container";
import WrongEnvironmentModal from "./_components/WrongEnvironmentModal";
import ModalMessage from "./_components/ModalMessage";

class CommunicationMain extends Component {
    state = {
        isComposing: false,
        modalOpen: false,
        deleteMsg: null,
    };

    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        detail: bool.isRequired,
        isWrongEnvironmentModalVisible: bool.isRequired,
        correctEnvironmentName: string.isRequired,
        wrongEnvironmentMessageKey: string.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(communicationsActions.listTypesRequest());
        dispatch(communicationsActions.listRequest({ direction: "BANK_TO_CUSTOMER" }));
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell || prevProps.isDesktop !== isDesktop)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { dispatch, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop } = this.props;
        const homePath = getPostLoginHomePath(isUxDashboardImprovementsEnabled());
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["communications"],
            titleKey: "chat.title",
            goBackPath: homePath,
            rightContentMobile: !isDesktop ? this.renderEmbeddedComposeShortcut() : undefined,
        });
    };

    renderEmbeddedComposeShortcut = () => {
        const { dispatch } = this.props;
        return (
            <div className="toolbar-item toolbar-item-right mt-0">
                <Button
                    type="button"
                    onClick={() => dispatch(push("/communications/compose"))}
                    className="toolbar-btn view-close mx-0">
                    <Image src="images/plus.svg" styles={{ color: "white" }} />
                </Button>
            </div>
        );
    };

    handleComposeClick = (isReply) => {
        const { isDesktop, dispatch } = this.props;

        if (isDesktop) {
            if (isReply) {
                dispatch(communicationsActions.showReplyPanel());
            } else {
                dispatch(communicationsActions.showComposePanel());
            }
        } else {
            dispatch(push("/communications/compose"));
        }
    };

    isModalVisible = (e, state) => {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        this.setState({ modalOpen: state });
    };

    handleModalDelete = (deleteFunction) => {
        this.setState({ deleteMsg: deleteFunction });
    };

    handleComposeCloseClick = () => {
        const { dispatch, detail } = this.props;
        if (detail) {
            dispatch(communicationsActions.showReadPanel());
        } else {
            dispatch(communicationsActions.hideAllPanels());
        }
    };

    handleBackClick = () => {
        const { dispatch } = this.props;
        dispatch(push(getPostLoginHomePath(isUxDashboardImprovementsEnabled())));
    };

    closeModal = () => {
        const { dispatch } = this.props;
        dispatch(communicationActions.hideWrongEnvironmentModal());
    };

    render() {
        const {
            isDesktop,
            isWrongEnvironmentModalVisible,
            correctEnvironmentName,
            wrongEnvironmentMessageKey,
            embeddedInV3Shell,
        } = this.props;
        const { isComposing, modalOpen, deleteMsg } = this.state;
        const homePath = getPostLoginHomePath(isUxDashboardImprovementsEnabled());
        const showEmbeddedShellHeader = embeddedInV3Shell && isUxDashboardImprovementsEnabled() && !isDesktop;

        if (isDesktop) {
            return (
                <Fragment>
                    {!embeddedInV3Shell && <Notification scopeToShow="communications" />}
                    <WrongEnvironmentModal
                        isVisible={isWrongEnvironmentModalVisible}
                        isDesktop={isDesktop}
                        closeModal={this.closeModal}
                        environment={correctEnvironmentName}
                        warningMessageKey={wrongEnvironmentMessageKey}
                    />
                    <div className="admin-detail-head px-0">
                        <Head backLinkTo={homePath} />
                        <Head
                            title="chat.title"
                            isDesktop={isDesktop}
                            onAdd={this.handleComposeClick}
                            addLinkToLabel="communications.compose.message.new"
                        />
                    </div>
                    <MainContainer>
                        <div className="above-the-folds">
                            <Container
                                className="align-items-center mailing communications-desktop-cols"
                                gridClassName="form-content">
                                <Col className="col col-6 col-no-padding overflow-auto h-100">
                                    <List
                                        isDesktop={isDesktop}
                                        handleComposeCloseClick={this.handleComposeCloseClick}
                                        isModalVisible={this.isModalVisible}
                                        handleModalDelete={this.handleModalDelete}
                                    />
                                </Col>
                                <Col className="col col-6 messages-container overflow-auto h-100">
                                    <LeftPanel
                                        compose={isComposing}
                                        close={this.handleComposeCloseClick}
                                        reply={this.handleComposeClick}
                                        isDesktop={isDesktop}
                                        isModalVisible={this.isModalVisible}
                                        handleModalDelete={this.handleModalDelete}
                                    />
                                </Col>
                            </Container>
                        </div>
                    </MainContainer>
                    <ModalMessage
                        isVisible={modalOpen}
                        submitClick={deleteMsg}
                        cancelClick={(e) => this.isModalVisible(e)}
                    />
                </Fragment>
            );
        }
        return (
            <Fragment>
                {!embeddedInV3Shell && <Notification scopeToShow="communications" />}
                {!showEmbeddedShellHeader && (
                    <div className="admin-detail-head px-0">
                        <Head
                            title="chat.title"
                            titleClassName="header-mobile-title-background-blue"
                            headerClassName="blue-main-header-mobile"
                            isComposing={false}
                            isDesktop={isDesktop}
                            onBack={this.handleBackClick}
                            addLinkTo="/communications/compose"
                            showPlusIcon
                            addButtonFirstPosition
                            addButtonImageWhite
                        />
                    </div>
                )}
                <MainContainer viewContentStyle={isDesktop ? {} : { overflowY: "hidden" }}>
                    <WrongEnvironmentModal
                        isVisible={isWrongEnvironmentModalVisible}
                        isDesktop={isDesktop}
                        closeModal={this.closeModal}
                        environment={correctEnvironmentName}
                        warningMessageKey={wrongEnvironmentMessageKey}
                    />
                    <div className={`above-the-fold mailing ${isDesktop ? "" : "without-auto-margin"}`}>
                        <List
                            isDesktop={isDesktop}
                            isModalVisible={this.isModalVisible}
                            handleModalDelete={this.handleModalDelete}
                        />
                    </div>
                </MainContainer>
                <ModalMessage
                    isVisible={modalOpen}
                    submitClick={deleteMsg}
                    cancelClick={(e) => this.isModalVisible(e)}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    types: communicationsSelector.listTypes(state),
    detail: communicationSelectors.detail(state),
    isWrongEnvironmentModalVisible: communicationSelectors.isWrongEnvironmentModalVisible(state),
    correctEnvironmentName: communicationSelectors.correctEnvironmentName(state),
    wrongEnvironmentMessageKey: communicationSelectors.wrongEnvironmentMessageKey(state),
});

export default connect(mapStateToProps)(CommunicationMain);
